<template>
  <b-modal id="confirmuser" centered ref="confirmUserModal" size="xl" no-close-on-esc
    no-close-on-backdrop>
    <template #modal-header>
      <h5 class="modal-title">Confirm User Information</h5>
    </template>
    <template #default>
      <div class="confirm-user-body">
        <span class="errorMessage" v-if="v$.form.$error">Required fields cannot be blank.</span>
        <span class="errorMessage" v-if="v$.form.userName.$error && v$.form.userName.unvalidatior.$invalid">
          <br />Username cannot contain: |#,$%^&:&nbsp;?&lt;&gt;*{}~[]()"'/\+@= and spaces.
        </span>
        <span class="errorMessage" v-if="isUserCreationFailed && !v$.form.$error">User Creation failed.</span>
        <UserForm ref="userForm" :userDetails="form" :isConfirmUser="true" :startTabIndex=19 :isOpenInEditFlow="false"
          @onUserFormValue="setConfirmUserDetails">
        </UserForm>
        <AccessibleApplications
          v-if="accessibleApplicationAccount.accountName != '' && accessibleApplicationAccount.cadebillAccountNo != '' && user_name != ''"
          ref="accessibleApplications" name="confirmaccessibleApplications" :isConfirm="true" :username="user_name"
          :accessibleApplicationAccount="accessibleApplicationAccount" :selectedApplications="accessibleApplications"
          :isEditPermission="true"></AccessibleApplications>
      </div>
    </template>
    <template v-slot:modal-footer="{ ok, cancel, hide }" class="modal-footer">
      <b-button class="um-btn" @click="hideModal" tabindex="33">Back</b-button>
      <b-button class="um-btn" @click="ConfirmDetails" tabindex="32">Add User</b-button>
    </template>
  </b-modal>
  <ErrorMessage :errorMessage="error" callbackOnClose></ErrorMessage>
  <InfoPopup ref="InfoModel" :popupmessage="info.message" :title="info.title" src="confirm"></InfoPopup>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
</template>

<script>
import UserForm from "./shared/UserForm";
import AccessibleApplications from "./shared/AccessibleApplications";
import {
  required,
  minLength,
  helpers
} from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import service from "../services/api.services";
import { eventbus } from "../main";
import { Component as Loading } from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import ErrorMessage from "./shared/ErrorMessage";
import InfoPopup from "./shared/InfoPopup";
const unvalidatior = helpers.regex(/^[^|#,$%^&:;?<>*{}~[\]()"'/+@=\s]*$/i);
export default {
    setup() {
        return { v$: useVuelidate() };
    },
  name: "ConfirmUser",
  components: {
    UserForm,
    AccessibleApplications,
    Loading,
    ErrorMessage,
    InfoPopup
  },
  data() {
    return {
      defaultapplication: "",
      mesagetitle: "",
      form: {
        firstName: (this.userDetail.firstName),
        middleInitial: (this.userDetail.middleInitial),
        lastName: (this.userDetail.lastName),
        userName: (this.userDetail.userName),
        title: (this.userDetail.title),
        phone: (this.userDetail.phone),
        email: (this.userDetail.email),
        streetAddress: (this.userDetail.streetAddress),
        city: (this.userDetail.city),
        state: (this.userDetail.state),
        postalCode: (this.userDetail.postalCode),
        country: (this.userDetail.country),
        languagePreference: (this.userDetail.languagePreference),
      },
      accessibleApplicationList: this.accessibleApplications,
      error: "",
      info: { message: "", title: "" },
      isLoading: false,
      fullPage: true,
      isUserCreationFailed: false,
      user_name: this.userDetail.userName,
      userdetailsConfirm: {}
    };
  },
  props: {
    userDetail: {},
    accessibleApplicationAccount: {},
    accessibleApplications: { type: Array, default: () => [] },
    roleList: Array,
    accountContactRoles: Array,
    AssociatedAccount: String
  },
  watch: {
    userDetail: {
      handler(newVal) {
        if (newVal) this.user_name = newVal.userName;
      },
      deep: true
    }
  },
  validations: {
    form: {
      firstName: { required, minLength: minLength(1) },
      lastName: { required, minLength: minLength(1) },
      userName: { unvalidatior, required, minLength: minLength(1) },
      phone: { required },
      languagePreference: { required }
    }
  },
  mounted() {
    var that = this;
    eventbus.on("confirmOkChanges", function () {
      that.okChanges();
    });
    eventbus.on("setConfirmAccessibleApplications", function (data) {
      that.setConfirmAccessibleApplications(data);
    });
    eventbus.on("setConfirmApplicationSetting", function (title) {
      that.setConfirmApplicationSetting(title);
    });
  },
  methods: {
    hideModal: function () {
      this.$refs["confirmUserModal"].hide();
    },
    ConfirmDetails: function () {
      this.getUserInfovalue();
      this.getUserAccessibleApplications();
      this.v$.form.$touch();
      if (this.v$.form.$error) {
        return false;
      } else {
        this.ConfirmAndSaveUser();
      }
    },
    async ConfirmAndSaveUser() {
      this.prepareuserdetailsConfirm();
      this.isLoading = true;
      var that = this;
      await service
        .ConfirmAndSaveUser(
          this.userdetailsConfirm
        )
        .then(response => {
          if (response.data != null) {
            if (response.data.data == "successful" && response.data.contactId != "") {
              that.isLoading = false;
              that.info.message = "Information saved successfully";
              that.info.title = "Information";
              that.$refs.InfoModel.$refs["InfoPopupModel"].show();
              that.emitMethod(response.data.contactId);
            }
            else {
              that.isLoading = false;
              that.info.message = response.data;
              that.info.title = "Error";
              that.$refs.InfoModel.$refs["InfoPopupModel"].show();
            }
          }

        })
        .catch(error => {
          that.isLoading = false;
          console.log("api error:" + error);
        })
        .finally(() => {
          that.$store.dispatch("setIsPageDirty", false);
        });
    },
    emitMethod(contactId) {
      this.userdetailsConfirm.sfContactId = contactId;
      this.userdetailsConfirm.sfAccountId = this.userdetailsConfirm.AccountId;
      this.userdetailsConfirm.isEnable = true;
      this.userdetailsConfirm.isStatusRetrived = true;
      eventbus.emit("setAddedUser", this.userdetailsConfirm);
    },
    okChanges: function () {
      if (this.$refs.InfoModel && this.$refs.InfoModel.$refs["InfoPopupModel"])
        this.$refs.InfoModel.$refs["InfoPopupModel"].hide();
      this.userdetailsConfirm.userCreated = true;
      this.$bvModal.hide("confirmuser");
      this.$bvModal.hide("applicationsetting");
      this.$bvModal.hide("createuser");

      eventbus.emit("UserCreatedSuccessfully", this.userdetailsConfirm);
    },
    prepareuserdetailsConfirm: function () {
      this.userdetailsConfirm.firstName = (this.form.firstName);
      this.userdetailsConfirm.middleInitial = (this.form.middleInitial);
      this.userdetailsConfirm.lastName = (this.form.lastName);
      this.userdetailsConfirm.userName = this.form.userName;
      this.userdetailsConfirm.title = (this.form.title);
      this.userdetailsConfirm.email = this.form.email;
      this.userdetailsConfirm.phone = (this.form.phone);
      this.userdetailsConfirm.languagePreference = (this.form.languagePreference);
      this.userdetailsConfirm.streetAddress = (this.form.streetAddress);
      this.userdetailsConfirm.city = (this.form.city);
      this.userdetailsConfirm.state = (this.form.state);
      this.userdetailsConfirm.postalCode = (this.form.postalCode);
      this.userdetailsConfirm.country = (this.form.country);
      this.userdetailsConfirm.Permission = this.roleList;
      this.userdetailsConfirm.applicationDetails = this.accessibleApplicationList;
      this.userdetailsConfirm.userCreated = false;
      this.userdetailsConfirm.Enabled = true
      this.userdetailsConfirm.Roles = this.accountContactRoles;
      if (
        this.userDetail.AccountId == "" ||
        this.userDetail.AccountId == undefined
      )
        this.userdetailsConfirm.AccountId = this.AssociatedAccount;
      else {
        this.userdetailsConfirm.AccountId = this.userDetail.AccountId;
      }
    },
    setConfirmUserDetails: function (data) {
      this.form = data;
    },
    setConfirmAccessibleApplications: function (data) {
      this.accessibleApplicationList = data;
    },
    setConfirmApplicationSetting: function (title) {
      this.getUserInfovalue();
      var data = {
        title: title,
        userDetail: this.form
      };
      eventbus.emit("applicationSetting", data);
    },
    getUserAccessibleApplications: function () {
      this.$refs.accessibleApplications.getConfirmvalue();
    },
    getUserInfovalue: function () {
      if (typeof this.$refs.userForm != "undefined")
        this.$refs.userForm.getConfirmvalue();
    }
  }
};
</script>


<style scoped>
.adduserbtn {
  margin-left: 0.8em;
  background-color: #2c87f0;
  border: 1px solid #2c87f0;
  height: 2.6em;
  border-radius: 5px;
  font-size: 0.8em;
  color: white;
  width: 8.2em;
}

.ContentSection {
  font-weight: 600;
  font-size: 0.9rem;
}

.PermissionGroup {
  color: #2c87f0;
  margin-bottom: 0;
  font-size: 0.9rem;
}

.PermissionRole {
  padding-left: 0.8rem;
  padding-right: 3.8rem;
}

.PermissionRole label {
  margin-left: 0px;
  width: 252px;
  vertical-align: text-top;
  padding-top: 0px;
  margin-bottom: 0;
  font-size: 0.9rem;
}

.errorMessage {
  color: red;
  font-size: 0.9rem;
  font-weight: 500;
}

.confirm-user-body {
  padding-bottom: 0rem;
  padding-left: 17px;
}
</style>
<style>
.modal-backdrop {
  opacity: 0.5;
  transition: opacity 0.2s;
}

.modal-title {
  margin: auto;
}
</style>